<template>
<div class="login" style="height: 100%">
    <div class="login-container">
        <header class="header">
            <!-- <img src="../assets/imgs/artfont.png" alt=""> -->
            <!-- <span class="header_txt"> 智慧加油平台</span> -->
            <!-- <span class="header_tag"> - </span>
      企业后台 -->
        </header>
        <section class="login-content">
            <div class="login-bg">
                <div class="login-background"></div>
                <div class="loginbox">
                    <p class="login_title" style="font-size:20px;">
                        账号登录
                    </p>
                    <el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" label-width="100px" class="demo-ruleForm">
                        <el-form-item prop="username">
                            <el-input type="text" v-model="ruleForm2.username" auto-complete="on" placeholder="用户名">
                                <i slot="prefix" class="icon-number"></i>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="checkPass">
                            <el-input type="password" @keyup.enter.native="
                                        submitForm('ruleForm2')
                                    " v-model="ruleForm2.checkPass" auto-complete="off" placeholder="密码">
                                <i slot="prefix" class="icon-password"></i>
                            </el-input>
                        </el-form-item>
                        <!-- <el-form-item prop="mobile">
                            <el-input type="text" v-model="ruleForm2.mobile" auto-complete="on" placeholder="请输入手机号">
                                <i slot="prefix" class="icon-number"></i>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="code">
                            <div class="sp-row">
                                <el-input style="width:60%" type="text" v-model="ruleForm2.code" auto-complete="on" placeholder="验证码">
                                    <i slot="prefix" class="icon-number"></i>
                                </el-input>
                                <button class="btnCode font-size2" @click="sendCode">{{sendCodeBool ? '获取验证码':`${btnNum}s`}}</button>
                            </div>
                        </el-form-item> -->
                        <!-- <el-form-item prop="imgCode">
                            <div class="sp-row">
                                <el-input style="width:60%" type="text" v-model="ruleForm2.imgCode" auto-complete="on" placeholder="验证码">
                                    <i slot="prefix" class="icon-number"></i>
                                </el-input>
                                <img class="imgCode" @click="getCodeImg" :src="imgCodeUrl" />
                            </div>
                        </el-form-item> -->
                        <el-form-item>
                            <el-button type="primary" @click="submitForm('ruleForm2')">登录</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </section>
        <Bottom></Bottom>
    </div>
</div>
</template>

<script>
import Bottom from "@/components/bottom";
import {
    rap,
    fetch,
    Timer
} from "@/utils/common.js";
let url = {
    login: "/fep/pc/marketingAdminLogin/login",
    imgCode: "/fep/pc/marketingAdminLogin/img",
    sendCode: '/fep/pc/marketingAdminLogin/verificationCode'
};
url = rap(url);
export default {
    data() {
        var validatePass = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入用户名"));
            } else {
                if (this.ruleForm2.checkPass !== "") {
                    this.$refs.ruleForm2.validateField("checkPass");
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入密码"));
            } else {
                callback();
            }
        };
        return {
            imgCodeUrl: url.imgCode,
            btnNum: 60,
            vercodeTxt: '发送验证码',
            sendCodeBool: true,
            ruleForm2: {
                username: "",
                checkPass: "",
                code: "",
                mobile: ""
            },
            rules2: {
                username: [{
                    validator: validatePass,
                    trigger: "blur"
                }],
                checkPass: [{
                    validator: validatePass2,
                    trigger: "blur"
                }],
            },
        };
    },
    created() {
        this.getCodeImg()
    },
    methods: {
        sendCode() {
            if (!this.sendCodeBool) {
                return
            }
            fetch(url.sendCode, {
                    mobile: this.ruleForm2.mobile,
                })
                .then(({
                    data,
                    status,
                    message
                }) => {
                    if (status === 200) {

                        this.sendCodeBool = false;
                        this.CodeTimer = new Timer(60);
                        this.CodeTimer.run((num) => {
                            this.btnNum = num;
                        });
                        this.CodeTimer.end = () => {
                            this.btnNum = 60;
                            this.sendCodeBool = true;
                        };
                        this.$message.success('发送成功');
                    }
                })
                .catch((error) => {
                    this.$message.error(error.message)
                    console.log(error.message);
                });
        },
        login() {
            fetch(url.login, {
                username: this.ruleForm2.username,
                password: this.ruleForm2.checkPass,
                code: this.ruleForm2.code,
                mobile: this.ruleForm2.mobile

            }).then((res) => {

                if (res.status === 200) {
                    // let authCodeList = res.data.authCodeList.join("/");
                    // window.localStorage.setItem("authCodeList", authCodeList);
                    // window.localStorage.setItem(
                    //     "isFirstTimeLogin",
                    //     res.data.isFirstTimeLogin
                    // );
                    // console.log(res.data.authCodeList)
                    this.$router.push({
                        path: "/"
                    });
                    //window.location.reload()
                }
            });
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.login();
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        getCodeImg() {
            this.imgCodeUrl = url.imgCode + "?i=" + Math.random()
            // fetch(url.imgCode, {
            // }).then((res) => {
            //     if (res.status === 200) {
            //         this.imgCodeUrl = res.data

            //     }
            // });
        },
    },
    components: {
        Bottom,
    },
};
</script>

<style lang="scss" scoped>
.icon-number,
.icon-password {
    font-size: 16px;
    color: #888;
}

.sp-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.imgCode {
    width: 80px;
    height: 35px;
    background: #cccccc;
}

.header {
    height: 84px;
    line-height: 86px;
    padding-left: 150px;

    .header_txt {
        display: inline-block;
        color: $statered_color;
        padding-left: 150px;
    }

    .header_tag {
        display: inline-block;
        color: $statered_color;
        padding: 0px 10px;
    }
}

.section {
    position: fixed;
    top: 45px;
    left: 0;
    bottom: 0;
    right: 0;
    padding: 56.15% 0 0;
    background-size: cover;
    background-attachment: fixed;
    background: url("../assets/imgs/help.png") no-repeat top left;

    .loginbox {
        position: absolute;
        background: $bg_color;
        width: 252px;
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2),
            0 6px 20px 0 rgba(0, 0, 0, 0.19);
        padding: 15px 24px 144px 24px;
        right: 25%;
        top: 8%;

        .login_title {
            color: $statered_color;
            padding: 12px 0 2px 0;
            font-weight: bold;
        }
    }
}

.login-content,
.login-container {
    height: 100%;
}

.login-bg {
    overflow: hidden;
    height: 100%;
    position: relative;

    .login-background {
        height: 100%;
        background: url("../assets/imgs/help.png") no-repeat top center;
        // background-size: cover;
    }

    .loginbox {
        position: absolute;
        background: $bg_color;
        width: 252px;
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2),
            0 6px 20px 0 rgba(0, 0, 0, 0.19);
        padding: 15px 24px 144px 24px;
        right: 22%;
        top: 8%;

        .login_title {
            color: $statered_color;
            padding: 12px 0 2px 0;
            font-weight: bold;
        }
    }
}

.el-form-item {
    padding-top: 24px;
    margin-left: -100px;
}

.el-button--primary {
    width: 252px;
    height: 40px;
    //background: $btn_color;
}

.el-icon-info:before {
    position: absolute;
    padding: 14px 0 0px 10px;
}
</style>
<style lang="scss">
.login {
    .el-input__inner {
        padding-left: 30px;
        font-size: 12px;
    }
}

.login .el-container.is-vertical {
    height: 100%;
}

.login .el-main {
    padding: 0px;
}

.btnCode {
    width: 85px;
    height: 40px;
}
</style>
